export type VencidasType = "Nuevas" | "Por Vencer" | "";
export const OPTIONS_VENCIDAS: VencidasType[] = ["Nuevas", "Por Vencer"];
